Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.CrossDimensionViewFactory
  constructor: (session) ->
    @session = session
    @barMenuViewFactory = new Common.Dashboard.Charts.BarMenuViewFactory

  canHandle: (widget) ->
    return (widget.get('type') == 'cross_dimension_chart')

  create: (widget, data, isReadOnly, isResponsive) ->
    attribute = @session.findAttribute(widget.get('definition_code'))

    factory = new CustomerVisualMode.WidgetDataTranslatorFactory(@session.accountAttributes, attribute)
    dataTranslator = factory.create(widget.get('dimension'))
    crossDataTranslator = factory.create(widget.get('cross_dimension'))

    dataFormatter = new CustomerVisualMode.Charts.CrossDimensionDataFormatter(dataTranslator, crossDataTranslator)

    chartView = new CustomerVisualMode.Charts.HeatmapGraphChartView(dataFormatter.format(widget, data))
    sortDropdown = new Common.Sessions.SortDropdown(widget.get('sorting')) if widget.canSort()
    barMenu = @barMenuViewFactory.create(widget, data)

    new CustomerVisualMode.Charts.CrossDimensionView({
      widget: widget,
      chartView: chartView,
      barMenu: barMenu,
      sortDropdown: sortDropdown,
      data: data,
      session: @session,
      dataTranslator: dataTranslator,
      dataFormatter: dataFormatter,
      isReadOnly: isReadOnly,
      isResponsive: isResponsive
    })
